// src/services/api.js
const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const _eventCache = new Map(); // dedup analytics events within a 5s window

const getToken = () => localStorage.getItem('sh_token');
const getVisitorId = () => {
  let visitorId = localStorage.getItem('sho_visitor_id');
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem('sho_visitor_id', visitorId);
  }
  return visitorId;
};

const headers = () => ({
  'Content-Type': 'application/json',
  'X-Visitor-Id': getVisitorId(),
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
});

const request = async (method, path, body) => {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: headers(),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

export const api = {
  // Auth
  register: (body) => request('POST', '/auth/register', body),
  login: (body) => request('POST', '/auth/login', body),
  me: () => request('GET', '/auth/me'),

  // Malls
  getMalls: () => request('GET', '/malls'),
  getMall: (id) => request('GET', `/malls/${id}`),

  // Stores
  getStores: (mallId) => request('GET', `/stores${mallId ? `?mallId=${mallId}` : ''}`),
  getStore: (id) => request('GET', `/stores/${id}`),

  // Products
  getProducts: (storeId) => request('GET', `/products${storeId ? `?storeId=${storeId}` : ''}`),
  getProductsByMall: (mallId) => request('GET', `/products?mallId=${mallId}`),
  getProduct: (id) => request('GET', `/products/${id}`),

  // Coupons
  getCoupons: (storeId) => request('GET', `/coupons${storeId ? `?storeId=${storeId}` : ''}`),
  getCouponsByMall: (mallId) => request('GET', `/coupons?mallId=${mallId}`),
  redeemCoupon: (id) => request('POST', `/coupons/${id}/redeem`),
  myLocks: () => request('GET', '/coupons/my-locks'),

  // Geo
  updateLocation: (body) => request('POST', '/geo/location', body),
  getNearbyCoupons: (lat, lng, mallId) =>
    request('GET', `/geo/nearby-coupons?lat=${lat}&lng=${lng}&mallId=${mallId}`),

  // Notifications
  registerFcmToken: (fcmToken) => request('POST', '/notifications/token', { fcmToken }),

  // Search
  search: (q) => request('GET', `/search?q=${encodeURIComponent(q)}`),

  // Signals
  getSignals: () => request('GET', '/signals'),
  postSignals: (signals) => request('POST', '/signals', { signals }).catch(() => {}),

  // Analytics (fire-and-forget)
  trackEvent: (type, storeId, productId, couponId) => {
    const key = `${type}:${storeId}:${productId || ''}`;
    const lastFired = _eventCache.get(key) || 0;
    if (Date.now() - lastFired < 5000) return Promise.resolve();
    _eventCache.set(key, Date.now());

    const visitorId = getVisitorId();
    return request('POST', '/analytics/event', {
      type, storeId, visitorId,
      ...(productId ? { productId } : {}),
      ...(couponId ? { couponId } : {}),
    }).catch(() => {});
  },
};
